// extracted by mini-css-extract-plugin
export var block = "style-module--block--ac2bc";
export var container = "style-module--container--ea7a2";
export var pseudo = "style-module--pseudo--5dd13";
export var pseudoTriangle = "style-module--pseudo-triangle--8b553";
export var quest = "style-module--quest--7ac84";